<template>
  <blank-layout>
    <div class="bg-white text-gray-600 h-screen m-0">
      <div class="items-center flex justify-center relative h-screen">

        <div class="flex flex-col space-y-6 items-center">
          <img class="w-24 ml-4 mb-4" src="/img/brandpreneurship-logo.png" alt="Markencode App" />


          <div v-if="false" class="border-r-2 border-solid text-4xl pt-0 pr-5 pb-0 pl-5 text-center">
            {{ title }}
          </div>

          <div class="text-2xl text-center pl-5">
            {{ description }}
          </div>
        </div>
      </div>
    </div>
  </blank-layout>
</template>

<script>
import BlankLayout from "@/Shared/BlankLayout";

export default {
  components: {
    BlankLayout,
  },
  props: {
    status: Number,
  },
  computed: {
    title() {
      return {
        503: '503',
        500: '500',
        419: '419',
        404: '404',
        403: '403',
      }[this.status]
    },
    description() {
      // return {
      //   503: 'Sorry, we are doing some maintenance. Please check back soon.',
      //   500: 'Whoops, something went wrong on our servers.',
      //   419: 'Sorry, this page has expired.',
      //   404: 'Sorry, the page you are looking for could not be found.',
      //   403: 'Sorry, you are forbidden from accessing this page.',
      // }[this.status]

      return {
        503: 'Wir führen Wartungsarbeiten durch. Bitte versuchen Sie es bald erneut.',
        500: 'Upps, auf unseren Servern ist etwas schief gelaufen.',
        419: 'Diese Seite ist abgelaufen.',
        404: 'Die von Ihnen gesuchte Seite konnte nicht gefunden werden.',
        403: 'Sie haben keine Berechtigung, auf diese Seite zuzugreifen.',
      }[this.status]
    },
  },
}
</script>